import { ChevronDownIcon } from "@heroicons/react/24/solid";
import { FC } from "react";
import { NavLink } from "react-router-dom";

// <--- NavItemType --->
export interface MegamenuItem {
  id: string;
  image: string;
  title: string;
  items: NavItemType[];
}
export interface NavItemType {
  id: string;
  name: string;
  isNew?: boolean;
  href?: string;
  targetBlank?: boolean;
  children?: NavItemType[];
  megaMenu?: MegamenuItem[];
  onClick?: () => void; // Add onClick to NavItemType
  type?: "dropdown" | "megaMenu" | "none";
}

export interface NavigationItemProps {
  menuItem: NavItemType;
}

type NavigationItemWithRouterProps = NavigationItemProps;

const NavigationItem: FC<NavigationItemWithRouterProps> = ({ menuItem }) => {
  // ===================== MENU MAIN MENU =====================
  const renderMainItem = (item: any) => {
    return item.type === "dropdown" ? (
      <div className="inline-flex items-center text-sm xl:text-base font-medium text-white py-2 px-4 xl:px-5 rounded-full hover:text-white hover:bg-neutral-100 ">
        {item.name}
        <ChevronDownIcon
          className="ml-1 -mr-1 h-4 w-4 text-text-color"
          aria-hidden="true"
        />
      </div>
    ) : (
      <NavLink
        end
        target={item.targetBlank ? "_blank" : undefined}
        rel="noopener noreferrer"
        className={({ isActive }) =>
          `inline-flex items-center text-sm xl:text-base font-semibold text-text-color py-2 px-4 xl:px-5 rounded-none ${
            isActive ? "!font-semibold border-b-2 border-primary-100 " : ""
          }`
        }
        to={item?.url || "/"}
      >
        {item.name}
      </NavLink>
    );
  };

  switch (menuItem.type) {
    default:
      return <span className="menu-item">{renderMainItem(menuItem)}</span>;
  }
};

// Your component own properties

export default NavigationItem;
